import { useState, useCallback } from 'react';
import { getCourseKpiReport } from '../../service/AdminService/courseService';
import { showErrorMessage } from '../../components/shared/pagination/messages';

export const useCourseReport = () => {
    const [data, setData] = useState([]);
    
    const fetchCourseKpiReport = useCallback(async (page, pageSize, isCourseActive, searchText) => {
        try {
            const response = await getCourseKpiReport(page, pageSize, isCourseActive, searchText);
            if (response) {
                setData(response.content || []);
                return response;  
            }
        } catch (error) {
            showErrorMessage(error.message || "Failed to load KPI Data");
        } 
    }, []);

    return { data, fetchCourseKpiReport };
};